import { render } from "./paymentDetail.vue?vue&type=template&id=4d4dd368"
import script from "./paymentDetail.vue?vue&type=script&lang=js"
export * from "./paymentDetail.vue?vue&type=script&lang=js"

import "./paymentDetail.vue?vue&type=style&index=0&id=4d4dd368&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__